import { render, staticRenderFns } from "./ContactCS.vue?vue&type=template&id=68ef409c&scoped=true"
import script from "./ContactCS.vue?vue&type=script&lang=js"
export * from "./ContactCS.vue?vue&type=script&lang=js"
import style0 from "./ContactCS.vue?vue&type=style&index=0&id=68ef409c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef409c",
  null
  
)

export default component.exports